import { render, staticRenderFns } from "./register-cloud-secure-edge.vue?vue&type=template&id=3fd9c1dd&scoped=true&"
import script from "./register-cloud-secure-edge.vue?vue&type=script&lang=tsx&"
export * from "./register-cloud-secure-edge.vue?vue&type=script&lang=tsx&"
import style0 from "./register-cloud-secure-edge.vue?vue&type=style&index=0&id=3fd9c1dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd9c1dd",
  null
  
)

export default component.exports